const CountryCode = new Map();

CountryCode.set('india', '+91');

export default CountryCode;
